import * as yup from 'yup';
export var initialValues = {
  email: '',
  password: ''
};
export var validationSchema = yup.object({
  email: yup.string().email('Invalid email format').required('Email is required'),
  password: yup.string().min(6, 'Your password must be at least 6 characters long.').required('Password is required')
});